'use client'
import { Dispatch, ReactNode, SetStateAction, useState } from 'react';


type AudioConfigConfigProp = {
 setSelectedConf: Dispatch<SetStateAction<number>>
}

type PadDef = {
    id : number;
    name : string;
}

const pads:Array<PadDef> = [];

const ControolerConfig = (props: AudioConfigConfigProp):ReactNode =>{
    
    
    var gamePadStorage = localStorage.getItem('GamePad');
    var mobileUIStorage = localStorage.getItem('MobileUI');

    
    
    let gamePad = gamePadStorage ? parseInt(gamePadStorage) : -1;
    let mobileUI = mobileUIStorage ? parseInt(mobileUIStorage) > 0 : true;
    

    const [gamepad, set_gamepad ] = useState<number>(gamePad);
    const [mobileui, set_mobileui ] = useState<boolean>(mobileUI);
    const [padList, setPadList ] = useState<Array<PadDef>>(pads)

    const listPds = pads.map(pad => <option value={pad.id}>pad.name</option>);

    window.addEventListener('gamepadconnected', (e) => {
        const pad = e.gamepad;
        pads.push({id : pad.index, name: pad.id});
        setPadList(pads);
    });
    window.addEventListener('gamepaddisconnected', (e) => {
            const pad = e.gamepad;
            let i=0;
            while(i<pads.length){
                if(pads[i].id === pad.index)
                    pads.splice(i, 1);
                else
                    i++;
            }
            setPadList(pads);
    });
    

            
    return (
        <div className='container'>
            <div className='text-right'><button onClick={()=> props.setSelectedConf(0)}>x</button></div>
            <label htmlFor='gamepad-used'>gamepad</label>
            <select id="gamepad-used" defaultValue={gamepad}>
                <option value="-1">no pad</option>
                {listPds}
            </select>
            <label htmlFor='mobile-ui'>mobile UI</label><input type="checkbox" id='mobile-ui' value={1} checked={mobileui} onChange={(e) => {const val = e.target.checked; localStorage.setItem('MobileUI', val ?"1":"0");  set_mobileui(val)}}/>
        </div>
    );
}
export default ControolerConfig;
        